import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
           
            cf.registerFilter("nombre_unidad", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre_unidad + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase()) || (item.nombre_unidad + "")
                            .toLowerCase()
                            .includes(searchWord.toLowerCase());
                }, searchWord);
            });
           
            cf.registerFilter("sigla", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.sigla + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
       
            return cf.runFilters();
        },

        filterNombreUnidad(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: val
            });
        },
       
        filterSigla(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                sigla: val
            });
        },
     
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: ""
            });
          
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
            sigla: ""
            });
           
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/item_cargo_y_puesto/mixins/filtrosUnidades.js